import i18next from 'i18next';
import * as React from 'react';
import { SubscriptionLayout } from "subscription/subscriptionLayout"
import { AuthButtonPrimary } from 'utils/forms';


export const ManageSubscription = (props: {
    onClick?: () => void
    intro: string
  }) => (
    <SubscriptionLayout.Row id="account-manage-subscription">
      <SubscriptionLayout.Col kind="label">
        <p>{i18next.t('subscription:ManageSubscription')}</p>
      </SubscriptionLayout.Col>
      <SubscriptionLayout.Col kind="value">
        <p>{props.intro}</p>
        
        <AuthButtonPrimary
                    kind="button"
                    type="button"
                    onClick={props.onClick}
                    label={i18next.t("subscription:ManageSubscription")}
                  />
      </SubscriptionLayout.Col>
    </SubscriptionLayout.Row>
  )